import { curry, merge, get } from 'lodash';
import { push } from 'react-router-redux';
import { findContact, findGrouping } from '../../helpers/contacts';

import * as syncActionCreators from '../sync/index';

export function getContact(id, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const groups = getState().staticData.contactStatusGroups;
    return simpleIsoFetch.get(`/api/contacts/${id}`)
      .then(({body: {data: {items: [contact]}}}) =>
        findGrouping({contact, groups})
      )
      .then((data) => callback(null, data))
      .catch(callback);
  };
}

export function updateContact(newContact, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const { profile: { id = 0 } } = newContact;
    const groups = getState().staticData.contactStatusGroups;
    const store = getState();
    const contacts = get(store.admin.contacts, 'items', []);
    const current = findContact({profile: {id}}, contacts);
    return simpleIsoFetch.put(`/api/contacts/${id}`, {
      body: newContact
    })
    .then(() => merge({}, current, newContact))
    .then((contact) => findGrouping({contact, groups}))
    .then((data) => callback(null, data))
    .catch(callback);
  };
}

export function updateContactOnboardingEmailDate(newContact, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const { profile: { id = 0, lastBQPOnboardingEmailSentDate } } = newContact;
    const groups = getState().staticData.contactStatusGroups;
    const store = getState();
    const contacts = get(store.admin.contacts, 'items', []);
    const current = findContact({profile: {id}}, contacts);
    return simpleIsoFetch.put(`/api/contacts/${id}/updateContactOnboardingEmailDate/${lastBQPOnboardingEmailSentDate}`, {
      body: {
        contact: {
          profile: {
            id,
            lastBQPOnboardingEmailSentDate
          }
        }
      }
    })
      .then(() => merge({}, current, newContact))
      .then((contact) => findGrouping({contact, groups}))
      .then((data) => callback(null, data))
      .catch(callback);
  };
}

export function updateContactOwner(newContact, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const { profile: { id = 0 } } = newContact;
    const groups = getState().staticData.contactStatusGroups;
    // const store = getState();
    // const contacts = get(store.admin.contacts, 'items', []);
    // const current = findContact({profile: {id}}, contacts);
    const current = newContact;
    return simpleIsoFetch.put(`/api/contacts/${id}`, {
      body: newContact
    })
      .then(() => merge({}, current, newContact))
      .then((contact) => findGrouping({contact, groups}))
      .then((data) => callback(null, data))
      .catch(callback);
  };
}

export function deleteContact(newContact, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const { profile: { id = 0 } } = newContact;
    const groups = getState().staticData.contactStatusGroups;
    const store = getState();
    const contacts = get(store.admin.contacts, 'items', []);
    const current = findContact({profile: {id}}, contacts);
    return simpleIsoFetch.del(`/api/contacts/${id}`, {
      body: newContact
    })
    .then(() => merge({}, current, newContact))
    .then((contact) => findGrouping({contact, groups}))
    .then((data) => callback(null, data))
    .catch(callback);
  };
}

export function updateContactStatus(id, contactStatus, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const success = curry(callback, 2)(null);
    const groups = getState().staticData.contactStatusGroups;
    const store = getState();
    const contacts = get(store.admin.contacts, 'items', []);
    const current = findContact({profile: {id}}, contacts);
    simpleIsoFetch.put(`/api/contacts/${id}/status/${contactStatus}`)
      .then(() => merge({}, current, {profile:{ contactStatus }}))
      .then(contact => findGrouping({contact, groups}))
      .then(success)
      .catch(callback);
  };
}

export function goToPage(skip, limit, filters, terms) {
  return simpleIsoFetch => (dispatch) =>
    simpleIsoFetch.get({
      route: '/api/contacts',
      query: {
        order: 'desc',
        skip,
        limit,
        ...filters,
        terms,
      }
    })
    .then((data) => {
      dispatch(syncActionCreators.updateContactsPage(data.body.data));
    })
    .catch(err => console.error(err));
}

export function addTag(id, body, callback) {
  return simpleIsoFetch => dispatch => {

    simpleIsoFetch.post({
        route: `/api/contacts/${id}/tag`,
        body
      })
      .then(
        ({body:{data:items}}) => {
          if (callback) {
            return callback(null, items);
          }
          return items;
        }, (err) => {
          return callback(err, null);
    })
  .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }
  });
  };
}

export function deleteTag(id, body, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.del({
        route: `/api/contacts/${id}/tag`,
        body
      })
      .then(
        ({body:{data:items}}) => {
          if (callback) {
            return callback(null, items);
          }
          return items;
        }, (err) => {
          return callback(err, null);
    })
  .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }
  });
  };
}




// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/contacts.js